import ApologyStatusModel from '../Apis/ApologyStatus'
import Controller from './Controller'

export default class ApologyStatusController extends Controller {
  constructor() {
    super(new ApologyStatusModel())
  }
}
